import BrandedPage from '@/app/pages/ava/BrandedPage'
import UtilityProgramPage from '@/app/pages/program-enrollment/UtilityProgramPage'
import useProgramFromParams from '@/app/hooks/useProgramFromParams'
import LinkDiagram from 'features/logos/LinkDiagram'
import OptiwattLogo from '@/app/pages/autogrid/optiwatt-logo.webp'
import { Button } from '@/components'
import { IconNames } from '@/components/Icon/Icon'
import IconList, { IconListItem } from '@/components/IconList/IconList'
import { useNavigation } from '@/app/hooks'
import AvaLogo from '@/app/img/ava-logo.png'

type InformationList = {
  featherIcon: IconNames
  title: string
  subtitle: string
  tag: string
  tagTextColor: string
  tagBackgroundColor: string
}

export default function ProgramEnrollmentOfferPage() {
  const { utilityProgram, viewConfig } = useProgramFromParams()
  const navigate = useNavigation()

  const onNext = () => {
    if (!utilityProgram) {
      return
    }
    navigate.push('enroll')
  }

  const logo =
    process.env.REACT_APP_ENVIRONMENT !== 'production'
      ? AvaLogo
      : utilityProgram?.view_config_json?.logoUrl ?? ''

  return (
    <BrandedPage
      id="utility-plan-offer"
      title={viewConfig?.onboarding?.title ?? 'Fetching Utility Programs...'}
      subtitle={viewConfig?.onboarding?.subtitle ?? ''}
    >
      <UtilityProgramPage>
        <BrandedPage.Content>
          <div className="mb-8">
            <LinkDiagram logos={[logo, OptiwattLogo]} />
          </div>
          <IconList>
            {viewConfig?.onboarding?.informationList.map(
              (infoList: InformationList) => {
                return (
                  <IconListItem
                    title={infoList.title}
                    subtitle={infoList.subtitle}
                    featherIcon={infoList.featherIcon}
                    sheetProps={{
                      text: infoList.tag,
                      color: infoList.tagBackgroundColor,
                      textColor: infoList.tagTextColor,
                    }}
                  />
                )
              },
            )}
          </IconList>
          <BrandedPage.ButtonContainer>
            <Button id={'next-button'} onClick={onNext}>
              Next
            </Button>
          </BrandedPage.ButtonContainer>
        </BrandedPage.Content>
      </UtilityProgramPage>
    </BrandedPage>
  )
}
